import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Params = Api.Core.ContractConsent.Resend.IParams;
type Request = Api.Core.ContractConsent.Resend.IRequest;
type Response = Api.Core.ContractConsent.Resend.IResponse;
type Headers = Api.Core.ContractConsent.Resend.IHeaders;
const url = '/api/Sales/ContractConsent/Resend/:id/:requestType';
export default async function contractConsentResendApi(params: Params, body: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, params),
    body,
    headers: getDefaultHeaders(),
  });
}
